module.exports = __webpack_public_path__ + "05_mole.6f940f91.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer3/05_mole.png
// module id = s8ci
// module chunks = 0